
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manual/input_players",
      function () {
        return require("private-next-pages/manual/input_players.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manual/input_players"])
      });
    }
  